import { DefaultApi } from './api'
import { User, CompanyUsers } from './interfaces'

export const getUserData = () => DefaultApi.request<User>('/user/me', { method: 'GET' })

export const getUsers = () => DefaultApi.request<CompanyUsers>('/company/users', { method: 'GET' })
